import { ListBulletsIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const DocumentText = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <ListBulletsIcon size={Sizes[size]} weight="bold" color={fill} {...rest} />;
};

DocumentText.displayName = 'DocumentText';
